function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGeneralAssetIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 500 500",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("circle", {
    cx: 250,
    cy: 250,
    r: 250,
    style: {
      fill: "#2e2447"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 246.65,
    y1: 114.72,
    x2: 246.65,
    y2: 97.97,
    style: {
      fill: "none",
      stroke: "#fff",
      strokeMiterlimit: 10,
      strokeWidth: 13
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 246.65,
    y1: 198.76,
    x2: 246.65,
    y2: 181.91,
    style: {
      fill: "none",
      stroke: "#fff",
      strokeMiterlimit: 10,
      strokeWidth: 13
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M246.65,148.31c10.19,0,18.46,7.52,18.46,16.8s-8.27,16.8-18.46,16.8-18.46-7.52-18.46-16.8",
    style: {
      fill: "none",
      stroke: "#fff",
      strokeMiterlimit: 10,
      strokeWidth: 13
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M246.65,148.31c-10.2,0-18.46-7.52-18.46-16.8s8.26-16.79,18.46-16.79,18.46,7.52,18.46,16.79",
    style: {
      fill: "none",
      stroke: "#fff",
      strokeMiterlimit: 10,
      strokeWidth: 13
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M163.57,262.89l-30.39-26.34c-9.74-8.44-7.19-19-1.8-25.23h0a14.88,14.88,0,0,1,21-1.5l21.27,18.43,13.75,11.92a65,65,0,0,1,24.43,11.6c1.53,1.21,3,2.47,4.52,3.74h0c9.9,8.58,17.82,18.63,18.76,31.69,0,0,.19,88.87.09,139.83",
    style: {
      fill: "none",
      stroke: "#fff",
      strokeMiterlimit: 10,
      strokeWidth: 13
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M133.18,236.55h0c-8.26-7.15-22.31-23.64-22.31-23.64s-24.9-41-30-64.64h0A16.27,16.27,0,0,0,62.2,135.62h0c-9.13,1.55-7.31,15.73-5.39,24.79l.23,1.41c7.09,33.78,19.88,69.75,32.68,89.59,13.18,20.42,34.12,38.92,60.26,74C165.32,345.94,164,427,164,427",
    style: {
      fill: "none",
      stroke: "#fff",
      strokeMiterlimit: 10,
      strokeWidth: 13
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M336.43,262.89l30.39-26.34c9.74-8.44,7.19-19,1.8-25.23h0a14.88,14.88,0,0,0-21-1.5l-21.27,18.43L312.6,240.17a65,65,0,0,0-24.43,11.6c-1.53,1.21-3.05,2.47-4.52,3.74h0c-9.9,8.58-17.82,18.63-18.76,31.69,0,0-.35,88-.32,139.83",
    style: {
      fill: "none",
      stroke: "#fff",
      strokeMiterlimit: 10,
      strokeWidth: 13
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M366.82,236.55h0c8.26-7.15,22.31-23.64,22.31-23.64s24.9-41,30-64.64h0a16.27,16.27,0,0,1,18.64-12.65h0c9.13,1.55,7.31,15.73,5.39,24.79l-.23,1.41c-7.09,33.78-19.88,69.75-32.68,89.59-13.18,20.42-34.12,38.92-60.26,74C334.68,345.94,336,427,336,427",
    style: {
      fill: "none",
      stroke: "#fff",
      strokeMiterlimit: 10,
      strokeWidth: 13
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 246.65,
    cy: 148.37,
    r: 75.4,
    transform: "translate(62.19 369.32) rotate(-81.17)",
    style: {
      fill: "none",
      stroke: "#fff",
      strokeMiterlimit: 10,
      strokeWidth: 13
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGeneralAssetIcon);
export default __webpack_public_path__ + "static/media/general-asset-icon.1c91603486b0b9fd68cdbb720ba19aab.svg";
export { ForwardRef as ReactComponent };